/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 *
 * Modaldialog zur Bestätigung eines Vorgangs
 * +---------------------------------------------------+
 * | [Vorgang]                                         |
 * +---------------------------------------------------+
 * | [ABBRUCH]                                  [ OK ] |
 * +---------------------------------------------------+
 */
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import store from '../../store'
import { ModalTitle } from "./ModalTitle";

export const ConfirmModal = ({ children, dialog, type, title, onConfirm = null, onCancel = null }) => {
    const { modalDialog } = store.getState().app;

    if (!(modalDialog.dialog === dialog && modalDialog.type === type)) return null;

    const confirmButtonText = (type === 'needLogin') ? 'Login' : 'OK';

    return (
        <Dialog fullWidth={true} open={true} maxWidth={'xs'}>
            <ModalTitle onClose={onCancel}>{title}</ModalTitle>
            <DialogContent dividers>
                {children}
            </DialogContent>
            <DialogActions>
                {onCancel && <Button onClick={onCancel} variant="outlined" color="default" >Abbruch</Button>}
                <div className="flex-grow"></div>
                {onConfirm && <Button onClick={onConfirm} variant="contained" color="primary">{confirmButtonText}</Button>}
            </DialogActions>
        </Dialog>
    )
}